import React from 'react';
import './style.css';
import { Layout, Menu, Breadcrumb } from 'antd';
import { useSelector } from 'react-redux';
import { authSelector } from '../../Auth/authSlice';
import Container from '../../Layout/Container';
import ClerkDashboard from './Clerk/Dashboard'
const { Header, Content, Footer } = Layout;

export default function Dashboard() {

  const { user } = useSelector(
    authSelector
  );

  return (
    <>
   <Container>
   {/* <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>List</Breadcrumb.Item>
        <Breadcrumb.Item>App</Breadcrumb.Item>
      </Breadcrumb> */}
   <div className="site-layout-content" style={{marginTop:5}}>
   <ClerkDashboard/>
    
    </div>
  </Container>
    </>
  );
}
